'use client';
import { memo } from 'react';

import { goTo } from 'shared/lib';
import IconButton from 'shared/IconButton';

import Arrow from 'assets/icons/ArrowRightLong.svg';
import { FORM_ID } from 'constants/global';

const CustomIconButtonComponent = () => (
  <IconButton
    icon={Arrow}
    iconProps={{
      boxSize: { mobile: '29px', tablet: '25px', laptop: '49px' },
      objectFit: 'contain',
    }}
    boxSize={{ mobile: '60px', tablet: '68px', laptop: '130px' }}
    onClick={() => goTo(FORM_ID)}
  />
);

export const CustomIconButton = memo(CustomIconButtonComponent);
